/**
 * @generated SignedSource<<a1faec691463bed2ea2c558c32a416ff>>
 * @relayHash a1b6aebb0a3efe580078f09140cd9804
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b87d0eb948f5407df1811406c925f73088ce67bb0d369b4469a01bdf115f2114

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type ConfluenceCreateWorkflowApplicationRequestInput = {
  contentId: string;
  contentStatus: GraphQLContentStatus;
  isActive?: boolean | null | undefined;
  version?: number | null | undefined;
  workflowId?: AGG$Long | null | undefined;
  workflowStatusId?: AGG$Long | null | undefined;
};
export type ApprovalsContextCreateWorkflowApplicationMutation$variables = {
  cloudId: string;
  createWorkflowApplicationRequestInput: ConfluenceCreateWorkflowApplicationRequestInput;
};
export type ApprovalsContextCreateWorkflowApplicationMutation$data = {
  readonly confluence_createWorkflowApplication: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
    readonly workflowStatus: {
      readonly allowsReviews: boolean | null | undefined;
      readonly displayProperties: {
        readonly color: string | null | undefined;
        readonly description: string | null | undefined;
        readonly icon: string | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ApprovalsContextCreateWorkflowApplicationMutation = {
  response: ApprovalsContextCreateWorkflowApplicationMutation$data;
  variables: ApprovalsContextCreateWorkflowApplicationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "createWorkflowApplicationRequestInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "createWorkflowApplicationRequestInput",
    "variableName": "createWorkflowApplicationRequestInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "concreteType": "ConfluenceApprovalsWorkflowStatus",
  "kind": "LinkedField",
  "name": "workflowStatus",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "allowsReviews"
    },
    {
      "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
      "kind": "LinkedField",
      "name": "displayProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        {
          "kind": "ScalarField",
          "name": "color"
        },
        {
          "kind": "ScalarField",
          "name": "icon"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ApprovalsContextCreateWorkflowApplicationMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_createWorkflowApplication",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          },
          (v7/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApprovalsContextCreateWorkflowApplicationMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_createWorkflowApplication",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          },
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a1b6aebb0a3efe580078f09140cd9804",
    "id": "b87d0eb948f5407df1811406c925f73088ce67bb0d369b4469a01bdf115f2114",
    "metadata": {},
    "name": "ApprovalsContextCreateWorkflowApplicationMutation",
    "operationKind": "mutation",
    "text": "mutation ApprovalsContextCreateWorkflowApplicationMutation($cloudId:ID!,$createWorkflowApplicationRequestInput:ConfluenceCreateWorkflowApplicationRequestInput!){confluence_createWorkflowApplication(cloudId:$cloudId,createWorkflowApplicationRequestInput:$createWorkflowApplicationRequestInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowStatus{id,allowsReviews,displayProperties{name,description,color,icon}}}}"
  }
};
})();

(node as any).hash = "c3c0d131e6ac8750fb00ef4b6b3fad85";

export default node;
